'use client';

import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import MediaView from "@/app/features/shared/media-view/ui/public/MediaView.public";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";
import { Box } from "@mui/material";

interface ImageSliderProps {
    images: MediaRef[]
}

const SLIDE_DURATION = 5000;
const ANIMATION_DURATION_SEC = 1;

export default function ImageSlider({ images }: ImageSliderProps) {

    const [currentIndex, setCurrentIndex] = useState<number>(0);

    const nextSlide = (): void => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, SLIDE_DURATION);

        return () => {
            clearInterval(interval);
        };
    });

    return (
        <Box
            sx={{
                position: 'relative',
                height: '100%',
                width: '100%',
            }}
        >
            <AnimatePresence initial={false}>
                <ImageContainer
                    key={`current-${currentIndex}`}
                    initial={{ opacity: 1 }}
                    animate={{ opacity: 0 }}
                    exit={{ opacity: 1 }}
                    transition={{ duration: ANIMATION_DURATION_SEC, ease: 'easeInOut' }}
                >
                    <MediaView
                        src={images[currentIndex] || '/assets/placeholder.webp'}
                        zoomOnHover={false}
                        slots={{
                            image: {
                                style: {
                                    objectFit: 'cover',
                                    width: '100%',
                                    height: '100%',
                                },
                            }
                        }}
                        fill
                    />
                </ImageContainer>
                <ImageContainer
                    key={`next-${currentIndex}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: ANIMATION_DURATION_SEC, ease: 'easeInOut' }}
                >
                    <MediaView
                        src={images[currentIndex]}
                        zoomOnHover={false}
                        fill
                        slots={{
                            root: {
                                style: {
                                    width: '100%',
                                }
                            },
                            image: {
                                className: "object-cover",
                            }
                        }}
                    />
                </ImageContainer>
            </AnimatePresence>
        </Box>
    )
}

export const ImageContainer = styled(motion.div)(() => ({
    position: 'absolute',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));
